import * as CL from '@design-system/component-library';
import { Grid } from '../Grid/Grid.js';
import { dsClass } from '../../common/constants/dsClasses';
import {
  elisaMobiiliivarmenneContentMsg,
  elisaMobiiliivarmenneLinkMsg,
  elisaMobiiliivarmenneMsg,
  elisaMobiiliivarmenneSmallHeaderMsg,
  t,
} from '../../common/i18n';

import './Mobiilivarmenne.scss';

export const Mobiilivarmenne = () => (
  <Grid>
    <CL.Grid>
      <CL.GridRow>
        <CL.GridCol colWidthXS={12} colWidthS={7} colWidthL={7} className={dsClass.PADDING_RIGHT_3}>
          <h3>{t.ELMO(elisaMobiiliivarmenneMsg)}</h3>
          <h4>{t.B75I(elisaMobiiliivarmenneSmallHeaderMsg)}</h4>
          <p>{t.SX92(elisaMobiiliivarmenneContentMsg)}</p>
        </CL.GridCol>
        <CL.GridCol colWidthXS={12} colWidthS={5} colWidthL={5} className="of-mobiilivarmenne--link-block">
          <CL.LinkBlock
            icon={<CL.Icon icon="external-link" />}
            border="top"
            onClick={() => window.open('https://yrityksille.elisa.fi/ohjeet/mobiilivarmenne', '_blank')}
          >
            {t.MBXP(elisaMobiiliivarmenneLinkMsg)}
          </CL.LinkBlock>
        </CL.GridCol>
      </CL.GridRow>
    </CL.Grid>
  </Grid>
);
